/*jshint esversion: 8 */
import React, { Component } from "react";
// import clsx from  'clsx';

import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { withStyles } from "@material-ui/core/styles";

// import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Paper from "@material-ui/core/Paper";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";

import ButtonGroup from "@material-ui/core/ButtonGroup";
import Button from "@material-ui/core/Button";
import store from "../../../components/stores/Store";

// add dialog
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
// import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from "@material-ui/core/DialogTitle";

import {
  deleteDeveloperUser,
  updateDeveloperUser,
} from "../../../db/DeveloperRequestHandler";

import { getIfFuncAuthorized } from "../../../utils/CheckSomething";

import CheckHandler from "../../../utils/CheckHandler";
import ITextField from "../../../components/UI/ITextField";

const styles = {
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    // marginBottom: theme.spacing(2),
  },
  tableContainer: {
    maxHeight: "450px", // todo
    maxWidth: "100%", // todo
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
};
// TableOfRoomManagement
class TableOfDeveloperUserManagementInner extends Component {
  constructor() {
    super();
    store.setOrderByOfTableConfig("developerId");
    store.setOrderOfTableConfig("desc");
    this.state = {
      login: true,
      page: 0,
      rowsPerPage: 10,
      updateLineDialogOpen: false,
      updateLineParams: {
        developerID: "",
        name: "",
        mobileNumber: "",
      },
      selected: [],
      deleteLineDialogOpen: false,
      toDeleteId: '',
    };
    this.descendingComparator = this.descendingComparator.bind(this);
    this.getComparator = this.getComparator.bind(this);
    this.stableSort = this.stableSort.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);

    this.handleChangePage = this.handleChangePage.bind(this);

    this.sortHandler = this.sortHandler.bind(this);

    this.deleteLine = this.deleteLine.bind(this);
    this.openUpdateLineDialog = this.openUpdateLineDialog.bind(this);
    this.closeUpdateLineDialog = this.closeUpdateLineDialog.bind(this);
    this.updateLine = this.updateLine.bind(this);
    this.closeDeleteLineDialog = this.closeDeleteLineDialog.bind(this);
    this.openDeleteLineDialog  = this.openDeleteLineDialog.bind(this);
  }

  async componentDidMount() { }
  componentWillUnmount() { }

  descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => this.descendingComparator(a, b, orderBy)
      : (a, b) => -1 * this.descendingComparator(a, b, orderBy);
  }

  handleChangePage(event, newPage) {
    console.log(`----- handleChangePage-newPage: `, newPage);
    this.setState({ page: newPage });
  }

  handleChangeRowsPerPage(event) {
    console.log(`----- handleChangeRowsPerPage-event: `, event);
    this.setState({ rowsPerPage: parseInt(event.target.value, 10) });
    this.setState({ page: 0 });
  }

  sortHandler(event, header) {
    if (!header.sortable) return;
    const orderBy = header.id;
    const order   = (orderBy === store.tableConfig.orderBy && store.tableConfig.order === 'asc') ? 'desc' : 'asc';
    store.setOrderOfTableConfig(order);
    store.setOrderByOfTableConfig(orderBy);
    store.setCurrentPageOfTableConfig(0);
    store.search();
  }

  closeDeleteLineDialog() {
    this.setState({
      toDeleteId: '',
      deleteLineDialogOpen: false,
    });
  }

  openDeleteLineDialog(e, id) {
    this.setState({
      toDeleteId: id,
      deleteLineDialogOpen: true,
    });
  }

  async deleteLine() {
    const id = this.state.toDeleteId;
    this.closeDeleteLineDialog();
    console.log(`----- send req of deleteLine`);
    const rst = await deleteDeveloperUser({ ID: id });
    //  console.log(`----- deleteDeveloperUser rst: `, rst);
    if (rst.code === "error") {
      store.openMessageDialogOpen(rst.msg || "删除错误");
      return true;
    } else if (rst.code === "success") {
      store.search();
      store.openMessageDialogOpen(rst.msg || "删除成功");
      return true;
    }
  }

  async openUpdateLineDialog(e, row) {
    this.setState({
      updateLineDialogOpen: true,
      updateLineParams: {
        ID: row.ID,
        developerID: row.developerId,
        name: row.userName,
        mobileNumber: row.phoneNumber,
      },
    });
  }

  async closeUpdateLineDialog(e, row) {
    this.setState({
      updateLineDialogOpen: false,
      updateLineParams: {
        ID: "",
        developerID: "",
        name: "",
        mobileNumber: "",
      },
    });
  }

  onUpdateLineDialogParamsChange(e, prop) {
    e.stopPropagation();
    const newUpdateLineParams = this.state.updateLineParams;
    newUpdateLineParams[prop] = e.target.value;
    this.setState({ updateLineParams: newUpdateLineParams });
  }

  async updateLine() {
    const ID = this.state.updateLineParams.ID.trim();
    const developerID = this.state.updateLineParams.developerID.trim();
    const mobileNumber = this.state.updateLineParams.mobileNumber.trim();
    const name = this.state.updateLineParams.name.trim();

    const chkRst = CheckHandler.checkParams([
      { key: "销售ID", value: ID, notNull: true, type: "", maxLength: 64 },
      {
        key: "开发商名",
        value: developerID,
        notNull: true,
        type: "",
        minLength: 36,
        maxLength: 36,
      },
      {
        key: "手机号码",
        value: mobileNumber,
        notNull: true,
        type: "phone",
        maxLength: 11,
      },
      { key: "销售姓名", value: name, notNull: true, type: "", minLength: 2, maxLength: 16 },
    ]);
    if (chkRst.msg) {
      store.openMessageDialogOpen(chkRst.msg);
      return;
    }

    // todo 手机号不变无法修改
    const rst = await updateDeveloperUser({
      ID: ID,
      userName: name,
      phoneNumber: mobileNumber,
      developerId: developerID,
    });
    if (rst.code === "error") {
      store.openMessageDialogOpen(rst.msg || "系统错误");
      return true;
    } else if (rst.code === "success") {
      console.log(`----- rst: `, rst);
      store.search();
      this.closeUpdateLineDialog();
      store.openMessageDialogOpen(rst.msg || "添加成功");
      return true;
    }
  }

  render() {
    const { classes } = this.props;
    const headCells = [
      {
        id: "developerId",
        align: "right",
        label: "所属开发商",
        sortable: true
      },
      {
        id: "phoneNumber",
        align: "right",
        label: "账号/手机号",
        sortable: true
      },
      {
        id: "userName",
        align: "right",
        label: "姓名",
        sortable: true
      },
      {
        id: "action",
        align: "center",
        label: "操作",
        sortable: false
      },
    ];

    const emptyRows =
      this.state.rowsPerPage -
      Math.min(
        this.state.rowsPerPage,
        store.table.length - this.state.page * this.state.rowsPerPage
      );

    return (
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <TableContainer>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size={"small"}
              aria-label="enhanced table"
              id="TableOfDeveloperUser"
            >
              <TableHead>
                <TableRow>
                  {headCells.map((headCell) => (
                    <TableCell
                      key={headCell.id}
                      align={headCell.align}
                      padding="normal"
                      sortDirection={
                        store.tableConfig.orderBy === headCell.id
                          ? store.tableConfig.order
                          : false
                      }
                    >
                      {headCell.sortable && (
                        <TableSortLabel
                          active={store.tableConfig.orderBy === headCell.id}
                          direction={
                            store.tableConfig.orderBy === headCell.id
                              ? store.tableConfig.order
                              : "asc"
                          }
                          onClick={(event) =>
                            this.sortHandler(event, headCell)
                          }
                        >
                          {headCell.label}
                          {store.tableConfig.orderBy === headCell.id ? (
                            <span className={classes.visuallyHidden}>
                              {store.tableConfig.order === "desc"
                                ? "sorted descending"
                                : "sorted ascending"}
                            </span>
                          ) : null}
                        </TableSortLabel>
                      )}

                      {!headCell.sortable  && (
                        <TableSortLabel hideSortIcon>
                          {headCell.label}
                        </TableSortLabel>
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {this.stableSort(
                  store.table,
                  this.getComparator(store.tableConfig.order, store.tableConfig.orderBy)
                )
                  .slice(
                    this.state.page * this.state.rowsPerPage,
                    this.state.page * this.state.rowsPerPage +
                    this.state.rowsPerPage
                  )
                  .map((row, index) => {
                    const labelId = `${index}`;
                    let developerName = "";

                    for (
                      let index = 0;
                      index < store.developerTable.length;
                      index++
                    ) {
                      const element = store.developerTable[index];
                      if (element.ID === row.developerId) {
                        developerName = element.name;
                        break;
                      }
                    }

                    return (
                      <TableRow hover tabIndex={-1} key={row.ID}>
                        <TableCell
                          component="th"
                          align="right"
                          id={labelId}
                          scope="row"
                          padding="normal"
                          style={{ width: "10%" }}
                        >
                          {developerName}
                        </TableCell>
                        <TableCell
                          align="right"
                          padding="normal"
                          style={{ width: "10%" }}
                        >
                          {row.phoneNumber}
                        </TableCell>
                        <TableCell
                          align="right"
                          padding="normal"
                          style={{ width: "10%" }}
                        >
                          {row.userName}
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ width: "20%" }}
                          padding="normal"
                        >
                          <ButtonGroup
                            variant="contained"
                            aria-label="contained primary button group"
                            padding="normal"
                          >
                            {getIfFuncAuthorized("房票管理-开发商用户管理-修改")
                              && (
                                <Button
                                  color="primary"
                                  onClick={(e) =>
                                    this.openUpdateLineDialog(e, row)
                                  }
                                  style={{ width: '200px' }}
                                >
                                  修改
                                </Button>
                              )}
                            {getIfFuncAuthorized("房票管理-开发商用户管理-删除")
                              && (
                                <Button
                                  color="secondary"
                                  onClick={(e) => this.openDeleteLineDialog(e, row.ID)}
                                  style={{ width: '200px' }}
                                >
                                  删除
                                </Button>
                              )}
                          </ButtonGroup>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 33 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 20, 40]}
            component="div"
            count={store.table.length}
            rowsPerPage={this.state.rowsPerPage}
            page={this.state.page}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
          />
        </Paper>

        <Dialog
          open={this.state.updateLineDialogOpen}
          onClose={(e) => this.closeUpdateLineDialog(e)}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">修改开发商用户</DialogTitle>
          <DialogContent>
            <FormControl fullWidth>
              <InputLabel
                id="demo-simple-select-outlined-label"
                style={{ marginTop: "-8px" }}
              >
                房产商名称
              </InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={this.state.updateLineParams.developerID}
                onChange={(e) =>
                  this.onUpdateLineDialogParamsChange(e, "developerID")
                }
                label="房产商名称"
                margin="dense"
              >
                <MenuItem value="">
                  <em>请选择</em>
                </MenuItem>
                {store.developerTable.map((row, index) => {
                  const ID = row.ID;
                  const name = row.name;
                  return (
                    <MenuItem value={ID} key={ID}>
                      {name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <ITextField
              autoFocus
              margin="dense"
              id="mobileNumber"
              label="*手机号"
              fullWidth
              ivalue={this.state.updateLineParams.mobileNumber}
              onChange={(e) =>
                this.onUpdateLineDialogParamsChange(e, "mobileNumber")
              }
              type="phone"
              maxLength="11"
              notNull
            />
            <ITextField
              margin="dense"
              id="name"
              label="*姓名"
              fullWidth
              ivalue={this.state.updateLineParams.name}
              onChange={(e) => this.onUpdateLineDialogParamsChange(e, "name")}
              type=""
              minLength="2"
              maxLength="16"
              notNull
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(e) => this.updateLine(e)}
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
            >
              确认修改
            </Button>
            <Button
              onClick={(e) => this.closeUpdateLineDialog(e)}
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
            >
              取消
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.deleteLineDialogOpen}
          onClose={this.closeDeleteLineDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" style={{width: '400px'}}>
            {"确认删除？"}
          </DialogTitle>
          <DialogActions>
            <Button onClick={this.deleteLine} color="secondary">
              确认删除
            </Button>
            <Button onClick={this.closeDeleteLineDialog} color="primary" autoFocus>
              取消
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const TableOfDeveloperUserManagement = observer(
  TableOfDeveloperUserManagementInner
);

TableOfDeveloperUserManagement.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TableOfDeveloperUserManagement);
